// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1KE6W","title":"BackImages_title__hrv-Z","images":"BackImages_images__1Yjox"};